import { Component, OnInit, AfterViewInit } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {


  login_data = {
    email: '',
    password: ''
  };

  constructor(
    public _globalService: GlobalService,
    private _router: Router
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    $('#emojionearea1').emojioneArea({
      pickerPosition: 'top',
      tonesStyle: 'bullet'
    });
  }

  onLogin() {
    this._globalService.global_loader = true;
    this._globalService.login(this.login_data.email, this.login_data.password)
      .then((res) => {
        // console.log('login', res);
        this._globalService.global_loader = false;
        if (!res.emailVerified) {
          this._globalService.openSnackBar('please verify your email', 'Dismiss');
          this._globalService.is_verification_link_shown = true;
        } else {
          this._globalService.getCurrentUserProfile();
        }
      })
      .catch((err) => {
      //  console.log(`error ${err}`);
       this._globalService.global_loader = false;
        this._globalService.openSnackBar(err, 'Dismiss');
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts